import React, { useEffect, useState } from "react"
import styled from "styled-components"
import { VisibilityContext } from "react-horizontal-scrolling-menu"
import { motion } from "framer-motion"
import CornerIcon from "./CornerIcon.svg"
import styles from "./CoronationOverview.module.css"
import SplitText from "../../../../components/SplitText"

const Holder = styled.div`
  width: 60vw;
  height: calc(100vh - 5px);
  background-color: #361b50;
  display: flex;
  flex-direction: column;
  padding-top: 5vw;
  align-items: center;
  gap: 3vw;
  user-select: none;
  pointer-events: none;
`
const TitleHolder = styled.div`
  text-align: center;
`
const CaptionHolder = styled(motion.div)`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: 70%;
  background-color: #b1a3ba;
  text-align: center;
  padding: 2em;
  &:after {
    content: "";
    background-image: url(${CornerIcon});
    background-size: cover;
    width: 2vw;
    height: 2vw;
    position: absolute;
    top: 1vw;
    left: 1vw;
  }
  &:before {
    content: "";
    background-image: url(${CornerIcon});
    background-size: cover;
    width: 2vw;
    height: 2vw;
    position: absolute;
    bottom: 1vw;
    right: 1vw;
    transform: rotateZ(180deg);
  }
`

const CommentHolder = styled.div`
  text-align: justify;
`

export default function CoronationOverview({ itemId }) {
  const visibility = React.useContext(VisibilityContext)
  const visibleContext = visibility.isItemVisible(itemId)

  const [titleVisible, setTitleVisible] = useState(false)
  const [captionVisible, setCaptionVisible] = useState(false)
  const [commentVisible, setCommentVisible] = useState(false)

  useEffect(() => {
    setTitleVisible(visibleContext)
    setCaptionVisible(visibleContext)
    setCommentVisible(visibleContext)
  }, [visibleContext])

  return (
    <Holder className={styles.holder}>
      <TitleHolder>
        <motion.div
          variants={{
            visible: {
              opacity: 1
            },
            hidden: {
              opacity: 0
            }
          }}
          initial="hidden"
          animate={titleVisible ? "visible" : "hidden"}
          transition={{
            ease: [0.455, 0.03, 0.515, 0.955],
            duration: 0.75,
            delay: 0.5
          }}
        >
          <SplitText
            className={styles.smallTitle}
            initial="hidden"
            animate={titleVisible ? "visible" : "hidden"}
            variants={{
              visible: i => ({
                y: 0,
                transition: {
                  ease: [0.455, 0.03, 0.515, 0.955],
                  duration: 0.75,
                  delay: i * 0.1
                }
              }),
              hidden: { y: "100%" }
            }}
          >
            Welcome to
          </SplitText>
          <SplitText
            className={styles.largeTitle}
            initial="hidden"
            animate={titleVisible ? "visible" : "hidden"}
            variants={{
              visible: i => ({
                y: 0,
                transition: {
                  ease: [0.455, 0.03, 0.515, 0.955],
                  duration: 0.95,
                  delay: i * 0.1
                }
              }),
              hidden: { y: "100%" }
            }}
          >
            Coronation|Square
          </SplitText>
        </motion.div>
      </TitleHolder>
      <CaptionHolder
        variants={{
          visible: {
            opacity: 1
          },
          hidden: {
            opacity: 0
          }
        }}
        initial="hidden"
        animate={captionVisible ? "visible" : "hidden"}
        transition={{
          ease: [0.455, 0.03, 0.515, 0.955],
          duration: 0.75,
          delay: 0
        }}
      >
        <div className={styles.largeCaption}>
          A PLACE WITH HEART.
          <br />A HOME TO LOVE.
        </div>
        <div style={{ height: "1em" }}></div>
        <div className={styles.smallCaption}>
          It is a place that connects people, from those who live here to
          <br />
          the wider Leyton community. A home where you’ll feel a<br />
          connection to your surroundings in the bustling streetscapes,
          <br />
          beautifully designed landscaped spaces and amenities nearby.
          <br />
          More than a new landmark address, it’s a new way of city living.
          <br />
        </div>
      </CaptionHolder>
      <CommentHolder>
        <motion.div
          variants={{
            visible: {
              opacity: 1
            },
            hidden: {
              opacity: 0
            }
          }}
          initial="hidden"
          animate={commentVisible ? "visible" : "hidden"}
          transition={{
            ease: [0.455, 0.03, 0.515, 0.955],
            duration: 0.75,
            delay: 0.9
          }}
        >
          <SplitText
            className={styles.comment}
            initial="hidden"
            animate={commentVisible ? "visible" : "hidden"}
            variants={{
              visible: i => ({
                y: 0,
                transition: {
                  ease: [0.455, 0.03, 0.515, 0.955],
                  duration: 0.75,
                  delay: i * 0.2
                }
              }),
              hidden: { y: "100%" }
            }}
          >
            From its thriving café scene and family-friendly restaurants to the
            High Road where| you can pop into Tesco and can’t miss the pop-art,
            there is a real sense of community| in Leyton. As part of a capital
            that is always changing Leyton reflects those changes| too, and
            today is a location of choice for everyone from creatives and tech
            workers to| young families. And while its urban pulse beats strong,
            you’ll find acres of open| spaces to unwind amongst the green and
            blue space we now know is vital for our well-being.
          </SplitText>
        </motion.div>
      </CommentHolder>
    </Holder>
  )
}
